import { Dialog, DialogHeader, DialogDescription, useIntl, Input, InputProps, Grid, GridRow } from "@metsooutotec/modes-react-components"
import { observer } from "mobx-react-lite"
import { FC, useState } from "react"
import { fetchSvgImageFromUrl, updateAssetSectionImage } from "../helpers/svg-helpers"
import { MapWearReferencePlane } from "../helpers/wear-reference-plane-helper"
import asEditorStor from "./../local-store/asset-section-editor-store"
import ModalsButtons from "components/common/modals-buttons"

interface SVGEditorWTModalProps {
    assetSectionId: string
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
    isModalOpen: boolean
}
interface WearReferencePlaneField {
    id: string
    label: string
    placeholder: string
    type: string
    validate?: (value: string) => string
}
const SVGEditorWearReferencePlaneModal: FC<SVGEditorWTModalProps> = observer(props => {
    const { selectedWearReferencePlane, setSelectedWearReferencePlane } = asEditorStor
    const { assetSectionImage, setAssetSectionImage } = asEditorStor
    const { formatMessage } = useIntl()
    const [wearReferencePlane, setWearReferencePlane] = useState<number>(0)
    const [errorMessage, setErrorMessage] = useState<string>("")
    const handleSubmit = async (e: React.FormEvent): Promise<void> => {
        e.preventDefault()
        try {
            //Map Wear Reference Plane
            const { svgDocument, renderedSvg } = await fetchSvgImageFromUrl(assetSectionImage as string)
            MapWearReferencePlane(
                props.assetSectionId,
                svgDocument,
                renderedSvg as SVGSVGElement,
                selectedWearReferencePlane,
                setSelectedWearReferencePlane,
                wearReferencePlane,
            )
            const blobUrl = await updateAssetSectionImage(svgDocument)
            setAssetSectionImage(blobUrl)
            onCloseProcess()
        } catch (e) {
            setErrorMessage("Somthing Wrong has been happen, please check the logs")
            console.error(e)
        }
    }
    const resetModal = () => {
        setErrorMessage("")
        setWearReferencePlane(0)
    }
    const onCloseProcess = (): void => {
        resetModal()
        props.setIsModalOpen(false)
    }
    const labels = {
        header: formatMessage("wearReferencePlaneModal.header"),
        description: formatMessage("wearReferencePlaneModal.description"),
        wearReferencePlane: formatMessage("wearReferencePlaneModal.wearReferencePlane"),
    }
    const inputConfig: WearReferencePlaneField[] = [
        { id: "wearReferencePlane", label: labels.wearReferencePlane, placeholder: `Type ${labels.wearReferencePlane} here...`, type: "number" },
    ]
    const handleChange = (stringValue: string) => {
        const value = parseFloat(stringValue)
        setWearReferencePlane(value)
    }
    const renderInputs = (): React.ReactNode => {
        return (
            <>
                {inputConfig.map((input: WearReferencePlaneField) => {
                    const { id, label, type, placeholder } = input
                    const inputProps: InputProps = {
                        id,
                        label,
                        placeholder,
                        onChange: (e: React.ChangeEvent<HTMLInputElement>) => handleChange(e.target.value),
                        type,
                        spanning: true,
                        heightClass: "medium",
                        required: true,
                        uiRequired: true,
                        value: wearReferencePlane,
                    }
                    return (
                        <GridRow key={id} style={{ marginBottom: "var(--size-m)" }}>
                            <Input {...inputProps} />
                        </GridRow>
                    )
                })}
            </>
        )
    }
    return (
        <Grid>
            <Dialog open={props.isModalOpen} size={"small"} style={{ maxWidth: "512px" }}>
                <DialogHeader username={""}>{labels.header}</DialogHeader>
                {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
                <DialogDescription style={{ marginBottom: "var(--size-xxl)" }}>{labels.description}</DialogDescription>
                {renderInputs()}
                <ModalsButtons handleSubmit={handleSubmit} onCloseProcess={onCloseProcess} isLoading={false} />
            </Dialog>
        </Grid>
    )
})

export default SVGEditorWearReferencePlaneModal
